import { parseAsArrayOf, parseAsString, useQueryStates } from "nuqs";

import { Classification } from "@/src/models/constants/classifications";
import { ProgressNote } from "@/src/models/documents/progress-note/progress-note";

/** Table row shape: the ProgressNote model plus the section classification the row came from. */
export interface ProgressNoteWithClassification extends ProgressNote {
  classification: Classification;
}

export const progressNoteQueryParams = {
  progressNoteClassification: parseAsArrayOf(parseAsString, ","),
};

export function useProgressNoteColumnFilters() {
  return useQueryStates(progressNoteQueryParams);
}
